// Grid-code version route (/admin/datasets/families/$familyId/versions/$versionLabel): the tab (build, preview, contents, runs, activity, file) in the URL; the screen is VersionPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { enumWithDefault } from "@/app/search";
import { VersionPage } from "@/features/datasets/VersionPage";

const VERSION_TABS = ["build", "preview", "contents", "runs", "activity", "file"] as const;

const searchSchema = z.object({
  tab: enumWithDefault(VERSION_TABS, "build"),
});

export const Route = createFileRoute("/_app/admin/datasets/families/$familyId/versions/$versionLabel")({
  validateSearch: searchSchema,
  staticData: { crumb: "Version" },
  component: VersionPage,
});
